import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import * as AzureMaps from "azure-maps-control";
import * as AzureMapsRest from "azure-maps-rest";

class AzureMap extends React.Component {
    componentDidMount() {
        const pickupAddress = this.props.pickupAddress;
        const deliveryAddress = this.props.deliveryAddress;

        const map = new AzureMaps.Map("map", {
            center: [131.033833, -25.352833],
            zoom: 2,
            language: "en-US",
            authOptions: {
                authType: "subscriptionKey",
                subscriptionKey: "olHPTgU93mZ4FpM8cZOwTVH3Fix05U8GNyaOI6gAWZ0",
            },
        });

        map.events.add("ready", function () {
            //Create a data source and add it to the map.
            var datasource = new AzureMaps.source.DataSource();

            map.sources.add(datasource);

            //Add a layer for rendering the route lines and have it render under the map labels.
            map.layers.add(
                new AzureMaps.layer.LineLayer(datasource, null, {
                    strokeColor: "#2272B9",
                    strokeWidth: 5,
                    lineJoin: "round",
                    lineCap: "round",
                }),
                "labels"
            );

            //Add a layer for rendering point data.
            map.layers.add(
                new AzureMaps.layer.SymbolLayer(datasource, null, {
                    iconOptions: {
                        image: ["get", "icon"],
                        allowOverlap: true,
                    },
                    textOptions: {
                        textField: ["get", "title"],
                        offset: [0, 1.2],
                    },
                    filter: ["any", ["==", ["geometry-type"], "Point"], ["==", ["geometry-type"], "MultiPoint"]], //Only render Point or MultiPoints in this layer.
                })
            );

            // Use SubscriptionKeyCredential with a subscription key
            var subscriptionKeyCredential = new AzureMapsRest.SubscriptionKeyCredential(
                "olHPTgU93mZ4FpM8cZOwTVH3Fix05U8GNyaOI6gAWZ0"
            );

            var pipeline = AzureMapsRest.MapsURL.newPipeline(subscriptionKeyCredential, {
                retryOptions: { maxTries: 4 }, // Retry options
            });

            var startAddress = null;
            var endAddress = null;

            // Create an instance of the SearchURL client.
            var searchURL = new AzureMapsRest.SearchURL(pipeline);

            if (pickupAddress && pickupAddress.location) {
                var queryPickupAddress = pickupAddress.line1;
                if (pickupAddress.line2 && pickupAddress.line2 !== "") {
                    queryPickupAddress += `, ${pickupAddress.line2}`;
                }

                if (pickupAddress.line3 && pickupAddress.line3 !== "") {
                    queryPickupAddress += `, ${pickupAddress.line3}`;
                }

                queryPickupAddress += `, ${pickupAddress.location.locality}`;
                queryPickupAddress += ` ${pickupAddress.location.state}`;
                queryPickupAddress += ` ${pickupAddress.location.postcode}`;

                var pickupOptions = { countrySet: [pickupAddress.location.country.is02] };

                searchURL
                    .searchAddress(AzureMapsRest.Aborter.timeout(10000), queryPickupAddress, pickupOptions)
                    .then((response) => {
                        if (response.results.length === 0) {
                            return;
                        }

                        var result = response.results[0];

                        startAddress = new AzureMaps.data.Feature(
                            new AzureMaps.data.Point([result.position.lon, result.position.lat]),
                            {
                                title: "Pickup",
                                icon: "pin-round-blue",
                            }
                        );

                        if (endAddress) {
                            datasource.add([startAddress, endAddress]);

                            // Construct the RouteURL object
                            var routeURL = new AzureMapsRest.RouteURL(pipeline);

                            //Start and end point input to the routeURL
                            var coordinates = [
                                [startAddress.geometry.coordinates[0], startAddress.geometry.coordinates[1]],
                                [endAddress.geometry.coordinates[0], endAddress.geometry.coordinates[1]],
                            ];

                            //Make a search route request
                            routeURL
                                .calculateRouteDirections(AzureMapsRest.Aborter.timeout(10000), coordinates)
                                .then((directions) => {
                                    //Get data features from response
                                    var data = directions.geojson.getFeatures();

                                    datasource.add(data);
                                });

                            map.setCamera({
                                bounds: AzureMaps.data.BoundingBox.fromData([startAddress, endAddress]),
                                padding: 80,
                                duration: 1000,
                                type: "fly",
                            });
                        }
                    });
            }

            if (deliveryAddress && deliveryAddress.location) {
                var queryDeliveryAddress = deliveryAddress.line1;
                if (deliveryAddress.line2 && deliveryAddress.line2 !== "") {
                    queryDeliveryAddress += `, ${deliveryAddress.line2}`;
                }

                if (deliveryAddress.line3 && deliveryAddress.line3 !== "") {
                    queryDeliveryAddress += `, ${deliveryAddress.line3}`;
                }

                queryDeliveryAddress += `, ${deliveryAddress.location.locality}`;
                queryDeliveryAddress += ` ${deliveryAddress.location.state}`;
                queryDeliveryAddress += ` ${deliveryAddress.location.postcode}`;

                var deliveryOptions = { countrySet: [deliveryAddress.location.country.is02] };

                searchURL
                    .searchAddress(AzureMapsRest.Aborter.timeout(10000), queryDeliveryAddress, deliveryOptions)
                    .then((response) => {
                        if (response.results.length === 0) {
                            return;
                        }

                        var result = response.results[0];

                        endAddress = new AzureMaps.data.Feature(
                            new AzureMaps.data.Point([result.position.lon, result.position.lat]),
                            {
                                title: "Delivery",
                                icon: "pin-blue",
                            }
                        );

                        if (startAddress) {
                            datasource.add([startAddress, endAddress]);

                            // Construct the RouteURL object
                            var routeURL = new AzureMapsRest.RouteURL(pipeline);

                            //Start and end point input to the routeURL
                            var coordinates = [
                                [startAddress.geometry.coordinates[0], startAddress.geometry.coordinates[1]],
                                [endAddress.geometry.coordinates[0], endAddress.geometry.coordinates[1]],
                            ];

                            //Make a search route request
                            routeURL
                                .calculateRouteDirections(AzureMapsRest.Aborter.timeout(10000), coordinates)
                                .then((directions) => {
                                    //Get data features from response
                                    var data = directions.geojson.getFeatures();
                                    datasource.add(data);

                                    map.setCamera({
                                        bounds: AzureMaps.data.BoundingBox.fromData([startAddress, endAddress]),
                                        padding: 80,
                                        duration: 1000,
                                        type: "fly",
                                    });
                                });
                        }
                    });
            }
        });
    }

    componentWillUnmount() {}

    shouldComponentUpdate() {
        return false;
    }

    render() {
        return (
            <div style={{ textAlign: "center", height: "100%" }}>
                <FontAwesomeIcon
                    icon={faCircleNotch}
                    size="6x"
                    color="white"
                    spin
                    style={{ verticalAlign: "middle", marginTop: "150px" }}
                />
            </div>
        );
    }
}

export default AzureMap;
